export default function addScript(videos: any) {
    const videoParameters = '&primaryColor=C9BA7C' + '&labelColor=0D381C';
    const script = document.createElement('script');
    const script2 = document.createElement('script');
    const script3 = document.createElement('script');
    const length = videos.length;

    /* applies the right amount of scipts depending on
    how many videos the performer has, removes them
    as soon as they are no longer needed */

    if (length === 0) {
        return null;
    } else if (length === 1) {
        script.id = 'video1';
        script.src =
            videos[0].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-0') +
            videoParameters;
    } else if (length === 2) {
        script.id = 'video1';
        script2.id = 'video2';
        script.src =
            videos[0].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-0') +
            videoParameters;
        script2.src =
            videos[1].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-1') +
            videoParameters;
    } else if (length === 3) {
        script.id = 'video1';
        script2.id = 'video2';
        script3.id = 'video3';
        script.src =
            videos[0].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-0') +
            videoParameters;
        script2.src =
            videos[1].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-1') +
            videoParameters;
        script3.src =
            videos[2].data.playerEmbedUrl.replace('{CONTAINER}', 'video-player-2') +
            videoParameters;
    }
    script.async = true;
    document.body.appendChild(script);
    document.body.appendChild(script2);
    document.body.appendChild(script3);
    document.body.removeChild(script);
    document.body.removeChild(script2);
    document.body.removeChild(script3);
}
